<template>
    <div 
        class="electronic-phantoms"
        :class="{ 'animate': doAnimate }"    
    >
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 682.89 682.89">
            <circle id="bg" class="cls-3" cx="341.45" cy="342.93" r="316.15"/>
            <g id="lights">
                <path class="cls-5" style="animation-delay: 0.7s;" d="M572.27,126.93l-65.95,406.32h8.48l93.7-371.08s-9.97-52.63-36.23-35.24Z"/>
                <path class="cls-5" style="animation-delay: 2.5s;" d="M636.05,225.08l-121.25,308.17,141.47-257.15s25.99-56.85-20.21-51.02Z"/>
                <path class="cls-5" style="animation-delay: 1.6s;" d="M178.53,64.65l78.85,450.12-29.76-479.07s-53.56,1.45-49.1,28.95Z"/>
                <path class="cls-5" style="animation-delay: 1s;" d="M103.82,129.7l53.89,389.53L74.18,173.61s-16.17-48.16,29.64-43.91Z"/>
                <path class="cls-5" style="animation-delay: 0;" d="M34.3,251.48l188.87,243.95L17.88,275.14s-1.37-32.53,16.42-23.66Z"/>
            </g>
            <linearGradient id="tower_00000174597404300419077140000004959026166712065410_" gradientUnits="userSpaceOnUse" x1="447.2193" y1="466.1707" x2="455.6898" y2="550.8764">
                <stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="0.8321" style="stop-color:#55555E"/>
            </linearGradient>
            <path id="tower" style="fill:url(#tower_00000174597404300419077140000004959026166712065410_);" d="M468.5,534.5
                c-2.8,3.6-5.6,7.2-8.4,10.8c-0.9,1.1-1.7,2.3-2.6,3.4c-1.3,1.6-2.8,1.7-4.1,0c-3.4-4.3-6.8-8.6-10.1-12.9c-0.3-0.4-0.7-0.8-1.1-1.2
                c-4.6,2.9-9,5.8-13.5,8.7c-3.1,2-6.2,4-9.3,6c-1.1,0.7-2.3,0.9-3.2-0.1c-1-1.1-0.7-2.2,0.2-3.2c10.3-12.8,17-27.4,22.5-42.8
                c6.1-17.2,10.2-34.9,13.2-52.8c0.5-2.9,0.8-5.8,1.2-8.6c0.2-1.9,1-2.9,2.3-2.9c1.3,0,2.1,1,2.3,2.9c3.4,25,9.1,49.4,18.8,72.7
                c4.6,11.2,10.3,21.8,18,31.3c0.9,1.1,1.3,2.2,0.3,3.4c-1.1,1.1-2.2,0.8-3.4,0.1c-7.3-4.7-14.5-9.4-21.8-14.1
                C469.2,534.9,468.9,534.7,468.5,534.5z M438.4,522.3c1.7,2.1,3.2,4.1,4.8,6.1c3.2-2.1,6.3-4.1,9.4-6.1c0.3-0.2,0.6-0.5,0.6-0.8
                c0-3.1,0-6.2,0-9.6C448.1,515.5,443.3,518.8,438.4,522.3z M457.6,512c0,3.4,0,6.3,0,9.2c0,0.4,0.3,1,0.6,1.3c3.1,2,6.2,4,9.3,6.1
                c1.6-2.1,3.1-4,4.8-6.1C467.5,518.9,462.7,515.5,457.6,512z M453.2,497.4c-2,1.4-3.7,2.7-5.5,3.6c-3.3,1.7-5.4,4.2-6.4,7.9
                c-0.7,2.5-1.9,5-2.8,7.5c0.3,0,0.4,0.1,0.5,0.1c4.5-3.1,9.1-6.3,13.6-9.5c0.3-0.2,0.6-0.7,0.6-1.1
                C453.2,503.1,453.2,500.5,453.2,497.4z M457.6,497.4c0,1.3,0.1,2.3,0,3.2c-0.7,4.3,0.8,7.2,4.7,9.3c3.4,1.8,6.4,4.4,9.9,6.8
                c-0.1-0.6-0.1-0.9-0.2-1.1c-1.4-3.6-2.7-7.1-4.1-10.6c-0.2-0.4-0.4-0.9-0.7-1.1C464.1,501.7,461,499.7,457.6,497.4z M453.2,469.6
                c-0.1,0-0.1,0-0.2,0c-2.4,9.1-4.8,18.1-7.2,27.4c2.3-1.5,4.5-3,6.6-4.5c0.4-0.3,0.7-0.9,0.7-1.4
                C453.2,483.9,453.2,476.7,453.2,469.6z M465,497c-2.5-9.3-4.8-18.4-7.2-27.4c-0.1,7.3-0.2,14.5-0.1,21.7c0,0.4,0.3,1,0.7,1.2
                C460.4,494,462.6,495.4,465,497z M426.9,539c4.4-2.9,8.4-5.5,12.5-8.1c-1.6-2.1-3.1-4-4.7-6C432.1,529.6,429.6,534,426.9,539z
                M483.9,539c-2.7-4.9-5.2-9.4-7.8-14.1c-1.6,2-3.1,4-4.7,6C475.5,533.6,479.5,536.2,483.9,539z M453,527.4c-2.5,1.6-4.7,3.1-7.1,4.6
                c2.4,3,4.6,5.9,7.1,9C453,536.3,453,532,453,527.4z M464.8,532c-2.4-1.6-4.7-3-7.1-4.6c0,4.6,0,8.9,0,13.7
                C460.2,537.9,462.4,535,464.8,532z"/>
            <path id="hills" class="cls-4" d="M476.09,541.55c-63.97,16.37-162.17-38.68-162.17-38.68,0,0-44.63-31.24-119.02-31.24-43.62,0-91.32,20.46-123.33,37.38,23.08,37.1,53.6,69.08,89.47,93.88l287.52-56.14-226.45,89.14c36.84,14.95,77.12,23.19,119.33,23.19,114.35,0,214.56-60.43,270.5-151.09-31.3-1.19-73.37,17.56-135.86,33.55Z"/>
            <path id="hand" class="cls-7" d="M460.88,208.25c1.27.29,5.43,1.17,9.48,1.17,3.16,0,6.25-.54,7.86-2.3.84-.92,1.65-2.59.76-5.25-2.87-8.62-13.02-12.04-15.43-12.74-.15-.04-.29-.11-.42-.2-3.16-2.17-21.79-14.86-37.21-23.4-.37-.2-.61-.55-.71-.96-2.43-10.03-15.49-15.52-17.6-16.35-.09-.03-.15-.06-.23-.11-3.78-2.36-51.97-32.61-73.2-49.6-22.24-17.79-53.79-29.87-54.07-29.97l-79.84-35.14c-.76-.31-1.63.05-1.94.81h0c-.31.76.05,1.63.81,1.94l79.88,35.16c.31.12,31.43,12.03,53.3,29.53,22.13,17.7,73.21,49.62,73.72,49.94l.27.13c.1.04,6.9,2.6,11.7,7.31,1.18,1.16-.17,3.09-1.67,2.41-3.48-1.59-6.43-2.65-8.51-2.91-9.32-1.17-18.89-10.27-21.91-13.36-.55-.57-1.45-.59-2.05-.07h0c-.63.57-.67,1.54-.08,2.15,3.24,3.35,13.31,12.94,23.67,14.23,11.41,1.43,53.96,30.7,54.39,30.99l.22.15.26.07c.11.03,11.15,2.9,13.83,10.93.53,1.57.04,2.11-.14,2.31-1.82,2-9.32,1.38-14.22.29-.09-.02-.17-.04-.25-.08-3.12-1.3-35.77-14.98-42.71-19.14-7.54-4.53-19.25-7.48-19.75-7.61l-68.2-17c-.51-.13-.92-.53-1.07-1.04-.32-1.12-.64-2.19-.94-3.23-1.23-4.2-2.23-7.65-2.81-10.37-.16-.78-.91-1.27-1.69-1.14h0c-.84.14-1.39.94-1.21,1.77.6,2.84,1.62,6.33,2.86,10.57,2.86,9.8,6.78,23.21,8.75,39.91,1.47,12.47.14,21.13-3.96,25.74-2.27,2.55-5.45,3.85-9.44,3.85-.81,0-1.45-.31-2-.97-3.37-4.02-1.86-17.66-1-22.58l.07-.4-.15-.38c-.49-1.29-12.23-31.79-25.86-40.88-7.71-5.14-11.89-15.69-15.92-25.9-2.75-6.96-5.35-13.53-9-18.39-3.87-5.16-24.49-15.09-61.27-29.5-23.66-9.27-46.76-17.54-52.58-19.61-.78-.28-1.62.13-1.89.91h0c-.27.77.13,1.62.9,1.89,30.25,10.7,105.48,38.77,112.47,48.09,3.41,4.55,5.94,10.94,8.62,17.7,4.21,10.63,8.56,21.62,17.04,27.28,11.71,7.8,22.52,33.92,24.43,38.71.1.25.13.51.09.78-.64,3.99-2.67,18.89,1.78,24.2,1.12,1.33,2.6,2.03,4.28,2.03,4.88,0,8.8-1.63,11.66-4.85,4.68-5.27,6.26-14.71,4.69-28.06-1.54-13.07-4.25-24.12-6.73-33.03l-.7-1.01v3.47c0,.61.36,1.15.92,1.38,3.19,1.29,14.41,5.65,30.01,10.31l-2.66-1.77c.54.6,14.92,16.89,28.07,24.56.3.17.52.44.64.76,2.07,5.82,12.43,32.88,26.08,32.88.67,0,1.36-.07,2.05-.2,3.77-.75,6.21-2.55,7.26-5.34,2.51-6.69-4.52-16.83-6.08-18.96-.09-.13-.16-.26-.21-.4l-.61-1.84c-.44-1.32,1-2.46,2.19-1.73,4.06,2.5,8.46,4.85,13.06,6.8.77.32,1.65-.06,1.96-.83h0c.3-.75-.06-1.6-.81-1.92-21.11-8.92-38.1-27.15-38.28-27.34l-.35-.38-.51-.08c-15.29-2.45-28.23-6.01-38.12-9.32-1.81-.61-1.01-3.32.84-2.85l42.63,10.63c.12.03,11.78,2.98,18.94,7.27.87.52,2.1,1.18,3.61,1.93.24.12.45.3.59.52l27.91,42.98c.04.07.08.13.11.2.63,1.42,3.81,6.9,15.59,7.51.27.01.52.02.77.02,2.89,0,4.83-.9,5.75-2.69,2.4-4.64-3.88-13.07-5.19-14.74-.02-.03-.03-.04-.05-.07-.39-.58-5.27-7.83-9.05-14.72-.68-1.24.59-2.63,1.89-2.08.77.32,1.26.53,1.41.59l.24.08ZM410.63,202.34l.08.47,3.05,9.16.15.2c2.27,2.95,7.76,11.66,5.95,16.49-.67,1.79-2.32,2.92-5.06,3.47-11.13,2.23-21.88-22.16-25.08-31.74l-.18-.55-.51-.28c-9.88-5.49-19.89-15.24-24.2-19.69,7.9,2.23,17.04,4.36,27.2,6.01,1.71,1.8,8.14,9.09,18.59,16.47ZM464.01,226.18c2.75,3.51,6.12,9.44,4.97,11.65-.53,1.02-2.32,1.14-3.73,1.07-11.05-.57-12.97-5.58-13.04-5.77l-.06-.19-25.74-39.64c7.57,3.51,17.69,7.88,24.97,10.97,3.42,8.34,12.19,21.27,12.63,21.91Z"/>
            <g id="stars">
                <polygon id="star4" class="cls-2 star" style="animation-delay: 0.2s;" points="56.54 368.97 52.07 383.85 35.71 386.82 52.07 389.8 56.54 404.68 59.51 389.8 74.84 386.82 59.51 383.85 56.54 368.97"/>
                <polygon id="star3" class="cls-2 star" style="animation-delay: 1.5s;" points="629.8 373.15 625.34 388.03 608.97 391 625.34 393.98 629.8 408.85 632.78 393.98 648.1 391 632.78 388.03 629.8 373.15"/>
                <polygon id="star2" class="cls-2 star" style="animation-delay: 2s;" points="508.96 114.78 504.5 129.66 488.13 132.63 504.5 135.61 508.96 150.49 511.93 135.61 527.26 132.63 511.93 129.66 508.96 114.78"/>
                <polygon id="star1" class="cls-2 star" style="animation-delay: 0.75s;" points="148.62 116.01 142.41 136.7 119.65 140.83 142.41 144.97 148.62 165.66 152.76 144.97 174.07 140.83 152.76 136.7 148.62 116.01"/>
                <polygon id="star5" class="cls-2 star" style="animation-delay: 1s;" points="391.94 49.22 385.73 69.91 362.97 74.05 385.73 78.19 391.94 98.88 396.07 78.19 417.39 74.05 396.07 69.91 391.94 49.22"/>
            </g>
            <g id="threads">
                <path class="cls-6" d="M338.15,193.3l-25.72,7.55,2.61,5.21s3.05-.81,7.32-1.67l-35.22,71.79,3.97,2.02,36.69-74.79c3.4-.53,7.05-.94,10.36-.98v-9.15Z"/>
                <path class="cls-6" d="M414.41,204.51l-2.95-4.83c-12.56-1.17-26.99.61-26.99.61l3.47,5.77,9.2-.54-21.69,87.39,2.89.72,21.83-87.96-1.06-.26,15.3-.9Z"/>
                <path class="cls-6" d="M471.92,314.29l-16.16-97.8c1.65-.41,3.43-.58,5.33-.38l-3.01-5.11s-11.38-1.22-18.26,10.68l3.79,3.56s3.5-5.16,9.3-7.76l16.08,97.29,2.94-.49Z"/>
                <path class="cls-6" d="M444.98,176.96c-8.8,7.35-10.57,19.95-10.57,19.95l1.1.48-23.47,103.86,2.9.66,23.34-103.3,2.43,1.07c1.81-11.58,8.8-19.82,8.8-19.82l-4.53-2.9Z"/>
                <polygon class="cls-6" points="438.06 306.85 435.08 306.82 435.89 214 438.89 218 438.06 306.85"/>
            </g>
            <g id="phantom">
                <polygon id="aircraft" class="cls-4" points="133.9 238.05 129.44 279.7 413.28 348.14 347.89 449.31 402.87 464.19 531.14 328.32 133.9 238.05"/>
                <g id="lights-2">
                    <ellipse class="cls-1" cx="169.61" cy="266.31" rx="8.93" ry="17.85" transform="translate(-129.36 367.83) rotate(-76.26)"/>
                    <ellipse class="cls-1" cx="319.38" cy="301.33" rx="8.93" ry="17.85" transform="translate(-49.17 540.02) rotate(-76.26)"/>
                    <ellipse class="cls-1" cx="465.18" cy="337.04" rx="8.93" ry="17.85" transform="translate(111.15 789.42) rotate(-87.88)"/>
                    <ellipse class="cls-1" cx="422.83" cy="398.42" rx="7.03" ry="14.07" transform="translate(-21.2 773.07) rotate(-83.45)"/>
                    <ellipse class="cls-1" cx="386.02" cy="447.45" rx="5.35" ry="12.85" transform="translate(-102.53 779.94) rotate(-83.45)"/>
                </g>
            </g>
            <g id="outer-ring">
                <path class="cls-8" d="M341.45,682.89c-91.2,0-176.95-35.52-241.44-100.01S0,432.65,0,341.45,35.52,164.5,100.01,100.01,250.24,0,341.45,0s176.95,35.52,241.44,100.01c64.49,64.49,100.01,150.24,100.01,241.44s-35.52,176.95-100.01,241.44c-64.49,64.49-150.24,100.01-241.44,100.01ZM341.45,29.22C169.29,29.22,29.22,169.29,29.22,341.45s140.06,312.22,312.22,312.22,312.22-140.06,312.22-312.22S513.61,29.22,341.45,29.22Z"/>
            </g>
            </svg>
    </div>
</template>

<script>
export default {
  name: 'badge-3',
  data() {
    return {
            counter: 0,
            intervalId: null,
            doAnimate: false
        }
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.doAnimate = true
            
            setTimeout(() => {
                this.doAnimate = false
            }, 8000)
        }, 15000)

        this.doAnimate = true
        setTimeout(() => {
            this.doAnimate = false
        }, 5000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
}
</script>

<style scoped>
.cls-1{fill:#eadea4;stroke:#ea1313;stroke-miterlimit:10;stroke-width:3px;}
.cls-2{fill:#f8f7f1;}
.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-width:0px;}
.cls-3{fill:#55555e;}
.cls-4{fill:#151515;}
.cls-5{fill:#c4c4c2;}
.cls-6{fill:#f20001;}
.cls-7{fill:#f0f2f0;}
.cls-8{fill:#ed0000;}

.electronic-phantoms * {
    transition: all 0.2;
}

@keyframes flicker {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes pan {
    from {
        transform: rotate(-1deg);
    }
    to {
        transform: rotate(1deg);
    }
}

#phantom {
    transform: translate(-60px, 20px) scale(0.8);
    opacity: 0.05;
    transition: all 1s;
}

.electronic-phantoms.animate #phantom,
.electronic-phantoms:hover #phantom {
    transform: translate(0, 0) scale(1);
    opacity: 1;
}

.star {
    opacity: 0.2;
}

#hand, #threads, #lights {
    opacity: 0;
}

.electronic-phantoms.animate .star,
.electronic-phantoms:hover .star {
    opacity: 1;
    animation: flicker 2s;
    animation-iteration-count: infinite;
}

.electronic-phantoms.animate #lights,
.electronic-phantoms:hover #lights {
    opacity: 1;
    transition: opacity 0.5s;
}

.electronic-phantoms #lights path {
    animation-name: pan;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    transform-origin: bottom;
    animation-direction: alternate;
}

#hand, #threads {
    transform: translate(-10px, -5px);
}

.electronic-phantoms.animate #hand,
.electronic-phantoms:hover #hand, 
.electronic-phantoms.animate #threads,
.electronic-phantoms:hover #threads {
    opacity: 1;
    transform: translate(0, 0);
    transition: all 1.25s;
}

.electronic-phantoms #tower {
    transition: all 1s;
}

.electronic-phantoms.animate #tower,
.electronic-phantoms:hover #tower {
    transform: translateY(50px);
    opacity: 0;
}
</style>
